import Device from '../Device';

const questions = [{
  type: 'savant-pairing-code',
  name: 'savantPairingCode',
  model: 'savantPairingCode',
  label: 'step3SavantPairingCode',
  show: (values, parent) => Boolean(parent.allQuestionsValid),
  active: true,
  mfg: 'savant',
  validation: 'required',
}];

const addDevice = async (values, context) => null;

const savant = new Device('savant', { mfg: 'savant', questions, addDevice });

export default savant;
